import { Validator } from 'vee-validate';
import moment from "moment";
const paramNames = ['reference'];

Validator.extend('time_gt', {
  getMessage: (field, args) => `The ${field} value must be greater than ${args[0]}`,
  validate: (value, args) => new Promise(resolve => {
    resolve({
      valid: moment(value,'HH:mm:ss').isAfter(moment(args.reference,'HH:mm:ss'))
    });
  })
},{
  paramNames
});

Validator.extend('time_gte', {
  getMessage: (field, args) => `The ${field} value must be greater than equal ${args[0]}`,
  validate: (value, args) => new Promise(resolve => {
    resolve({
      valid: moment(value,'HH:mm:ss').isSameOrAfter(moment(args.reference,'HH:mm:ss'))
    });
  })
},{
  paramNames
});

Validator.extend('time_lt', {
  getMessage: (field, args) => `The ${field} value must be less than ${args[0]}`,
  validate: (value, args) => new Promise(resolve => {
    resolve({
      valid: moment(value,'HH:mm:ss').isBefore(moment(args.reference,'HH:mm:ss'))
    });
  })
},{
  paramNames
});

Validator.extend('time_lte', {
  getMessage: (field, args) => `The ${field} value must be less than equal ${args[0]}`,
  validate: (value, args) => new Promise(resolve => {
    resolve({
      valid: moment(value,'HH:mm:ss').isSameOrBefore(moment(args.reference,'HH:mm:ss'))
    });
  })
},{
  paramNames
});

Validator.extend('time_equal', {
  getMessage: (field, args) => `The ${field} value must be equal ${args[0]}`,
  validate: (value, args) => new Promise(resolve => {
    resolve({
      valid: moment(value,'HH:mm:ss').isSame(moment(args.reference,'HH:mm:ss'))
    });
  })
},{
  paramNames
});


Validator.extend('time_between', {
  getMessage: (field, args) => `The ${field} value must be between ${args[0]} and ${args[1]}`,
  validate: (value, args) => new Promise(resolve => {
    resolve({
      valid: moment(value,'HH:mm:ss').isBetween(moment(args.min,'HH:mm:ss'),moment(args.max,'HH:mm:ss'))
    });
  })
},{
  paramNames : ['min','max']
});


Validator.extend('date_gt', {
  getMessage: (field, args) => `The ${field} value must be greater than ${args[0]}`,
  validate: (value, args) => new Promise(resolve => {
    resolve({
      valid: moment(value,'YYYY-MM-DD').isAfter(moment(args.reference,'YYYY-MM-DD'))
    });
  })
},{
  paramNames
});

Validator.extend('date_gte', {
  getMessage: (field, args) => `The ${field} value must be greater than ${args[0]}`,
  validate: (value, args) => new Promise(resolve => {
    resolve({
      valid: moment(value,'YYYY-MM-DD').isSameOrAfter(moment(args.reference,'YYYY-MM-DD'))
    });
  })
},{
  paramNames
});
